import * as React from "react";
import { forwardRef } from "react";
const SvgTextVerticalAlignBottom = (props, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 20, viewBox: "0 0 20 20", width: 20, xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m2 17h16m-8-3v-11m3 7.9999-3 3.0001-3-3.0001", stroke: "#2c2d32", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgTextVerticalAlignBottom);
export default ForwardRef;
